import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userShortInfo: null,
        currentUserId: 0,
        courseTypes: [],
        courseAttendantsTotal: 0,
        userCourseTotal: 0,
        userCourseType: 0,
        currentUser: null,
        courseAttendantsAnswersTotal: 0,
        courseLocation: {},
        totalEmailCount: 0,
        courseId: 0,
        courseName: '',
        courseTown: '',
        courseCounty: '',
        currentUserShortInfo: null,
        currentJunior: null,
        isMemberDiscounts: false
    },
    mutations: {
        setCourseId(state, val) {
            state.courseId = val;
        },
        setCourseName(state, val) {
            state.courseName = val;
        },
        setCourseTypes(state, val) {
            state.courseTypes = val;
        },
        setCourseAttendantsTotal(state, val) {
            state.courseAttendantsTotal = val;
        },
        setUserCourseTotal(state, val) {
            state.userCourseTotal = val;
        },
        setUserCourseType(state, val) {
            state.userCourseType = val;
        },
        setCurrentUser(state, val) {
            state.currentUser = val;
        },
        setCourseAttendantsAnswersTotal(state, val) {
            state.courseAttendantsAnswersTotal = val;
        },
        setCourseLocation(state, val) {
            state.courseLocation = val;
        },
        setTotalEmailCount(state, val) {
            state.totalEmailCount = val;
        },
        setCourseTown(state, val) {
            state.courseTown = val;
        },
        setCourseCounty(state, val) {
            state.courseCounty = val;
        },
        setUserShortInfo(state, val) {
            state.userShortInfo = val;
        },
        setCurrentUserShortInfo(state, val) {
            state.currentUserShortInfo = val;
        },
        setCurrentJunior(state, val) {
            state.currentJunior = val;
        },
        setIsMemberDiscounts(state, val) {
            state.isMemberDiscounts = val;
        }
    },
    getters: {
        getUserShortInfo: state => {
            return state.userShortInfo;
        },
        getCourseId: state => {
            return state.courseId;
        },
        getCourseName: state => {
            return state.courseName;
        },
        getCourseTypes: state => {
            return state.courseTypes;
        },
        getCourseAttendantsTotal: state => {
            return state.courseAttendantsTotal;
        },
        getUserCourseTotal: state => {
            return state.userCourseTotal;
        },
        getUserCourseType: state => {
            return state.userCourseType;
        },
        getCurrentUser: state => {
            return JSON.parse(JSON.stringify(state.currentUser));
        },
        getCourseAttendantsAnswersTotal: state => {
            return state.courseAttendantsAnswersTotal;
        },
        getCourseLocation: state => {
            return state.courseLocation;
        },
        getTotalEmailCount: state => {
            return state.totalEmailCount;
        },
        getCourseTown: state => {
            return state.courseTown;
        },
        getCourseCounty: state => {
            return state.courseCounty;
        },
        getCurrentUserShortInfo: state => {
            return state.currentUserShortInfo;
        },
        getCurrentJunior: state => {
            return state.currentJunior;
        },
        getIsMemberDiscounts(state, val) {
            return state.isMemberDiscounts;
        }
    }
});


// WEBPACK FOOTER //
// ./src/services/store.js